module.exports = __webpack_public_path__ + "img/D_icon_drinkcoach.75f60faf.svg";